var map = {
	"./AAP.svg": 7672,
	"./GPC.svg": 792,
	"./Landing_Page/TCS_Logo.svg.svg": 9002,
	"./Logo.svg": 1167,
	"./company_logos/Carrefour.svg": 4668,
	"./compare.svg": 6327,
	"./diagram.svg": 4788,
	"./logoTagline.svg": 3129,
	"./planning.svg": 3134,
	"./rating.svg": 9475,
	"./research.svg": 8930,
	"./tcsLogo.svg": 4341
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2994;